import(/* webpackMode: "eager" */ "/codebuild/output/src1977675865/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/global-error.tsx");
